export const hotkeys = {
  toggleSidebar: "meta+s,ctrl+s",
  toggleIntercom: "meta+h,ctrl+h",
  commandPalette: "meta+k,ctrl+k",
  goToDashboard: "g>d",
  goToTickets: "g>t",
  goToWorkflows: "g>w",
  goToAssets: "g>a",
  goToSoftware: "g>s",
  goToPeople: "g>p",
  goToSettings: "g>c",
  goToAdmin: "g>g>a",
  toggleTheme: "meta+m,ctrl+m",
  tabSettingsGeneral: "t>g",
  tabSettingsIntegrations: "t>i",
  tabSettingsKB: "t>k",
  tabSettingsAssets: "t>a",
  tabSettingsDesks: "t>d",
  tabSettingsPortal: "t>s",
  tabPreferencesPortal: "t>p",
  focusSearch: "slash",
  clearSearch: "escape",
  navigateUp: "ArrowUp",
  navigateDown: "ArrowDown",
  previousPage: "ArrowLeft",
  nextPage: "ArrowRight",
  refreshTable: "shift+r",
  resetFilters: "shift+x",
};
